import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { MTracingItem } from '../../models/tracing-item-model';
import { SieniService } from '../../services/sieni.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'reminder',
  templateUrl: './reminder.component.html',
  styleUrls: ['./reminder.component.scss']
})
export class ReminderComponent implements OnInit {

  constructor(private _globalServices: SieniService, private toastr: ToastrService, 
    private translate: TranslateService) { }

  @Output() private accept = new EventEmitter<string>();
  @Output() private dismiss = new EventEmitter<string>();
  @Output() private reject = new EventEmitter<string>();
  @Input() public item: MTracingItem = null;

  public message: string = ''
  public status: string = ''
  public fase: string = ''
  public sending: boolean = false;
  
  ngOnInit() {
    // console.log(this.item)
    switch (this.item.status.order) {
      case 1:
        this.status = 'register.crumbs.register'
        this.fase = 'register.crumbs.register'
        break;

      case 2:
        this.status = 'validation.crumbs.validation'
        this.fase = 'validation.crumbs.validation'
        break;

      case 3:
        this.status = 'tracing.sections.analisis'
        this.fase = 'treatment.title'
        break;

      case 4:
        this.status = 'tracing.sections.plan'
        this.fase = 'treatment.title'
        break;

      case 5:
        this.status = 'tracing.sections.verification'
        this.fase = 'treatment.title'
        break;

      case 6:
        this.status = 'tracing.sections.execution'
        this.fase = 'treatment.title'
        break;

      case 7:
        this.status = 'tracing.sections.efficacy'
        this.fase = 'treatment.title'
        break;

      default:
        this.status = 'tracing.sections.approval'
        this.fase = 'tracing.sections.approval'
        break;
    }
    // console.log(this.status)
  }
  
  public onDismiss(text: string){
    this.dismiss.emit(text)
  }

  public onAccept(text: string){
    this.sending = true;
    this._globalServices.sendReminder(this.item.id, this.item.fase.id, this.message).subscribe(res=>{
      // console.log(res)
      this.sending = false;
      // this.toastr.error(this.translate.instant("tracing.modal.error", {id: this.item.id}))

      this.accept.emit(text)
    }, err=>{
      this.toastr.error(this.translate.instant("tracing.modal.error", {id: this.item.id}))
      this.sending = false;
    })
  }

  public onReject(text: string){
    this.reject.emit(text)
  }
}
